<template>
    <v-navigation-drawer
        v-model="LocalDrawer"
        width="350px"
        app
        right
        temporary>
        <v-list dense class="pt-0">
            <v-list-item v-if="IsAuthenticated && HasUser" >
                <v-list-item-title>
                    <v-icon>account_circle</v-icon>
                    {{User.userName}}
                </v-list-item-title>
            </v-list-item>

            <v-list-group
                value="true"
                active-class="group-active"
                v-if="IsAuthenticated && CanWorkWithStatistic">
                <template #activator>
                    <v-list-item class="group-title pa-0">
                        {{ $t('text.statistic') }}
                    </v-list-item>
                </template>

                <v-list-item
                    class="pl-6"
                    v-for="(item, i) in statistic"
                    :key="i">
                    <nav-item :to="{name: item.to}" :title="item.title"></nav-item>
                </v-list-item>
            </v-list-group>
<!--
            <v-list-item v-if="IsAuthenticated && CanWorkWithManualBestlists">

                <nav-item
                    :to="{name: 'manualbestlists'}"
                    title="manualBestlistsTitle">
                </nav-item>
            </v-list-item>
-->
            <v-list-item v-if="IsAuthenticated && CanWorkWithLicense">
                <nav-item
                    :to="{name: 'license'}"
                    title="license">
                </nav-item>
            </v-list-item>

            <v-list-group
                value="true"
                active-class="group-active"
                v-if="IsAuthenticated">
                <template #activator>
                    <v-list-item class="group-title pa-0">
                        {{ $t('text.usermanagement') }}
                    </v-list-item>
                </template>

                <v-list-item
                    class="pl-6"
                    v-for="(item, i) in visibleItems(usermanagement)"
                    :key="i">
                    <nav-item :to="{name: item.to}" :title="item.title"></nav-item>
                </v-list-item>
            </v-list-group>

            <v-list-item v-if="IsAuthenticated && CanWorkWithCompApproval">
                <nav-item
                    :to="{name: 'competitionapproval'}"
                    title="competitionApproval">
                </nav-item>
            </v-list-item>

            <v-list-item v-if="IsAuthenticated && CanWorkWithRecords">
                <nav-item
                    :to="{name: 'recordsets'}"
                    title="recordSetsTitle">
                </nav-item>
            </v-list-item>

            <!-- <v-list-item v-if="IsAuthenticated && CanWorkWithManualBestlists">
                <nav-item
                    :to="{name: 'manualbestlists'}"
                    title="manualBestlistsTitle">
                </nav-item>
            </v-list-item> -->
            <!-- <v-list-item v-if="IsAuthenticated">
                <nav-item
                    :to="{name: 'eventregistration'}"
                    title="eventRegistration">
                </nav-item>
            </v-list-item> -->

            <v-list-item v-if="IsAuthenticated" >
                <nav-item :to="{name: 'login'}" title="logout"></nav-item>
            </v-list-item>

            <v-list-item v-if="!IsAuthenticated">
                <nav-item :to="{name: 'login'}" title="login"></nav-item>
            </v-list-item>

            <v-list-item v-if="!IsAuthenticated">
                <nav-item :to="{name: 'register'}" title="register"></nav-item>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';

import namespace from '../store/namespace';

import NavItem from './Item.vue';

export default {
	name: 'Slider',
	components: {
		NavItem,
	},
	props: {
		drawer: {
			type: Boolean,
			required: true,
		},
	},
	data() {
		return {
			statistic: [
				{
					to: 'bestlist',
					title: 'bestlist',
				},
				{
					to: 'performance',
					title: 'performance',
				},
				{
					to: 'competition',
					title: 'competition',
				},
			],
			usermanagement: [
				{
					to: 'usermanagement',
					title: 'user',
					show: () => (!!this.IsAuthenticated && !!this.CanWorkWithUserManagement),
				},
				{
					to: 'rolerequests',
					title: 'rolerequests',
					show: () => !!this.IsAuthenticated,
				},
			],
		};
	},
	computed: {
		...mapGetters(namespace.AUTH, ['IsAuthenticated']),
		...mapGetters(namespace.USER, ['IsLicenser', 'IsAdmin', 'HasUser', 'User', 'HasRoles', 'IsStatistiker', 'IsRecordAdmin', 'IsGerman', 'IsManualBestlistAdmin']),
		CanWorkWithCompApproval() {
			return this.HasRoles && this.IsGerman;
		},
		CanWorkWithUserManagement() {
			return this.HasRoles && this.IsAdmin;
		},
		CanWorkWithLicense() {
			return this.HasRoles && (this.IsLicenser || this.IsAdmin);
		},
		CanWorkWithStatistic() {
			return this.HasRoles && this.IsStatistiker;
		},
		CanWorkWithRecords() {
			return this.HasRoles && this.IsRecordAdmin;
		},
		CanWorkWithManualBestlists() {
			return this.HasRoles && this.IsManualBestlistAdmin;
		},
		LocalDrawer: {
			get() {
				return this.drawer;
			},
			set(value) {
				this.$emit('update', value);
			},
		},
	},
	methods: {
		visibleItems(items) {
			return items.filter(x => x.show() === undefined || x.show() === true);
		},
	},
};
</script>

<style lang="scss" scoped>
.group-active {
    color: #e4af0c !important;
}

.group-title {
    font-weight: 500;
    letter-spacing: .0892857143em;
    text-indent: .0892857143em;
    text-transform: uppercase;
    white-space: nowrap;
    font-size: .875rem;
}
</style>
